import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../../services/storage.service';

/**
 * Redirects users who are already logged in away from the public pages
 * (login/signup) and straight into the app, so reopening the browser does
 * not show the login screen while a valid session still exists in localStorage.
 */
export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const storage = inject(StorageService);
  const router = inject(Router);

  let alreadyAuthenticated = authService.isAuthenticated();

  // Backwards-compatible check: some sessions store the flag on the app state.
  if (!alreadyAuthenticated) {
    alreadyAuthenticated = Boolean(storage.loadAppState()?.isAuthenticated);
  }

  if (alreadyAuthenticated) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};